import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { CheckBox, ToolBar } from '@1c/ui';
import { omitRestEmpty } from '@1c/utils/lib/restApi';
import { useNavigate } from 'src/utils/useNavigate';
import { FinalField, FinalForm } from 'src/components/FinalForm';
import Button from 'src/components/Button';
import InputField from 'src/components/InputField';
import Text from 'src/components/Text';
import Link from 'src/components/Link';
import routes from 'src/constants/routes';
import { postStartEmailConfirmationAPI, putAccountProfileAPI } from 'src/serverApi/account';
import validate from './validate';
import styles from './styles.module.scss';

type Props = {
  onSubmit: () => void;
}

const AccountProfileForm: React.FC<Props> = ({ onSubmit }) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [personalDataAgreementChecked, setPersonalDataAgreementChecked] = useState(false);

  const setAccountProfile = async (data: any) => {
    try {
      setIsLoading(true);
      await putAccountProfileAPI(omitRestEmpty(data));
      await postStartEmailConfirmationAPI();
      onSubmit();
    } catch (error) {
      toast.error('Произошла ошибка. Попробуйте позже.');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePersonalDataAgreementClick = (value: any) => {
    setPersonalDataAgreementChecked(value?.currentTarget?.checked);
  };

  const handleSubmit = (values: any) => {
    setAccountProfile(values);
  };
  
  const handleBack = () => {
    navigate(routes.agent);
  }

  return (
    <>
      <Text type="p" muted>Завершение создания пользователя</Text>
      <FinalForm
        onSubmit={handleSubmit}
        submitting={isLoading}
        pristine
        initialValues={{
          firstName: null,
          secondName: null,
          middleName: null,
          email: null,
        }}
        validate={validate}
      >
        {({ submitting, pristine }: { submitting: any; pristine: any }) => {
          return (
            <div>
              <FinalField name="secondName">
                {({ value, onChange, error }: { value: string, onChange: any; error: string }) => (
                  <InputField
                    labelRequired
                    label="Фамилия"
                    value={value}
                    onChange={onChange}
                    error={error}
                    className={styles['input']}
                  />
                )}
              </FinalField>
              <FinalField name="firstName">
                {({ value, onChange, error }: { value: string, onChange: any; error: string }) => (
                  <InputField
                    labelRequired
                    label="Имя"
                    value={value}
                    onChange={onChange}
                    error={error}
                    className={styles['input']}
                  />
                )}
              </FinalField>
              <FinalField name="middleName">
                {({ value, onChange }: { value: string, onChange: any }) => (
                  <InputField
                    label="Отчество"
                    value={value}
                    onChange={onChange}
                    className={styles['input']}
                  />
                )}
              </FinalField>
              <FinalField name="email">
                {({ value, onChange, error }: { value: string, onChange: any; error: string }) => (
                  <InputField
                    labelRequired
                    label="E-mail"
                    value={value}
                    onChange={onChange}
                    error={error}
                    className={styles['input']}
                  />
                )}
              </FinalField>
              <CheckBox
                className={styles['checkbox']}
                checked={personalDataAgreementChecked}
                onChange={handlePersonalDataAgreementClick}
              >
                <Text type="span" muted small>Согласие </Text>
                <Link to={routes.offer} className={styles['link']} target="_blank">
                  на обработку персональных данных
                </Link>
              </CheckBox>
              <ToolBar align="center" className={styles['buttons']}>
                <Button variant="text" disabled={submitting} onClick={handleBack}>
                  Назад
                </Button>
                <Button
                  disabled={submitting || pristine || !personalDataAgreementChecked}
                  type="submit"
                >
                  Продолжить
                </Button>
              </ToolBar>
            </div>
          );
        }}
      </FinalForm>
    </>
  );
};

export default AccountProfileForm;
